const GraphicsIcon = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 24 24"  height="18px" width="18px">
       <path stroke-linecap="round" stroke-linejoin="round" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
  </svg>)
  };
  export default GraphicsIcon;
